import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "text-sm font-semibold mb-6",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = { class: "list-none p-0 inline-flex" }
const _hoisted_3 = ["href"]

import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AppBreadcrumb',
  props: {
    breadcrumb: {}
  },
  setup(__props: any) {

const props = __props
const breadcrumbName = computed(() => {
  // return props.breadcrumb.toUpperCase()
  return props.breadcrumb
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("li", { class: "flex items-center text-purple" }, [
        _createElementVNode("a", {
          href: "/dashboard",
          class: "text-gray-500"
        }, "Dashboard"),
        _createElementVNode("svg", {
          class: "fill-current w-3 h-3 mx-3 text-blue-600",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 320 512"
        }, [
          _createElementVNode("path", { d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" })
        ])
      ], -1)),
      (_openBlock(), _createElementBlock("li", {
        key: _ctx.index,
        class: "flex items-center"
      }, [
        _createElementVNode("a", {
          href: '/' + _ctx.breadcrumb,
          class: "text-gray-600"
        }, _toDisplayString(breadcrumbName.value), 9, _hoisted_3)
      ]))
    ])
  ]))
}
}

})